import { useToast } from 'primevue/usetoast';

export function useErrorToast() {
  const toast = useToast();

  const showErrorToast = (message = 'An error occurred!') => {
    toast.add({
      severity: "error",
      detail: "An error occurred!",
      closable: false,
      life: process.env.VUE_APP_TOAST_LIFE
    });
  };

  return {
    showErrorToast,
  };
}
